import {DosyaBorcluSSKCevap, SigortaDurumKod} from "./DosyaBorcluSSK";
import {DosyaBorcluEgmCevap, DosyaBorcluEgmTalep} from "./DosyaBorcluEgm";
import {DosyaBorcluMernisCevap} from "./DosyaBorcluMernis";
import {SgkKamuCevap} from "./SgkKamu";
import {BorcluGibCevap} from "./BorcluGib";
import {DosyaBorcluBagkurCevap} from "./DosyaBorcluBagkur";
import {DosyaBorcluBankaBilgileriCevap} from "./DosyaBorcluBankaBilgileri";
import {BorcluDibCevap} from "./BorcluDib";
import {DosyaBorcluIsyeriSgkCevap} from "./DosyaBorcluIsyeriSgk";
import {BorcluTakbisSorgulamaCevap} from "./BorcluTakbisSorgulama";
import {BorcluSgkHacizCevap} from "./BorcluSgkHaciz";
import {BorcluIskiCevap} from "./BorcluIski";
import {BorcluIcraDosyasiCevap} from "./BorcluIcraDosyasi";
import {BorcluGsmCevap} from "./BorcluGsm";
import {BorcluPostaCekiCevap} from "./BorcluPostaCeki";
import app from "@/main";
import {DosyaBorcluHacizInterface,} from "../haciz/HacizParamsInterfaces";
import {DosyaBorcluTebligatInterface} from "../haciz/TebligatParamsInterface";
import {DigerTalepParamsInterface} from "../haciz/TopluDigerTalepParamsInterface";
import {BorcluTur, IBorcluBilgileri, IKisiTumDVO, IKurumDVO} from "./CommonInterfaces";
import {SskEmekliCevap} from "@/plugins/uyap-plugin/uyap/SskEmekli";
import {BagkurEmekliCevap} from "@/plugins/uyap-plugin/uyap/BagkurEmekli";
import {SORGU_UCRETI} from "@/plugins/uyap-plugin/uyap/SorguBakiyeYukle";
import {DosyaBorcluMersisCevap} from "@/plugins/uyap-plugin/uyap/DosyaBorcluMersis";
import {BorcluTasinmazTakyidatSorgulamaCevap} from "@/plugins/uyap-plugin/uyap/BorcluTasinmazTakyidatSorgulama";
import {BorcluTasinmazHisseSorgulamaCevap} from "@/plugins/uyap-plugin/uyap/BorcluTasinmazHisseSorgulama";
import {BorcluBesCevap} from "@/plugins/uyap-plugin/uyap/BorcluBes";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";

export class DosyaBorclu {
    turu: BorcluTur;
    kisiKurumId: number;
    borcluBilgileri: IKisiTumDVO | IKurumDVO;
    sskAktif: boolean = false;
    ssk: DosyaBorcluSSKCevap | EmptyObject = new EmptyObject();
    egm: DosyaBorcluEgmCevap | EmptyObject = new EmptyObject();
    mernis: DosyaBorcluMernisCevap | EmptyObject = new EmptyObject();
    mersis: DosyaBorcluMersisCevap | EmptyObject = new EmptyObject();
    sgkkamu: SgkKamuCevap | EmptyObject = new EmptyObject();
    gib: BorcluGibCevap | EmptyObject = new EmptyObject();
    sgkbagkur: DosyaBorcluBagkurCevap | EmptyObject = new EmptyObject();
    emekliBagkur: BagkurEmekliCevap | EmptyObject = new EmptyObject();
    emekliSsk: SskEmekliCevap | EmptyObject = new EmptyObject();
    // todo: kamu har gelince güncellenecek
    emekliKamu: SskEmekliCevap | EmptyObject = new EmptyObject();
    bankaBilgileri: DosyaBorcluBankaBilgileriCevap | EmptyObject = new EmptyObject();
    dib: BorcluDibCevap | EmptyObject = new EmptyObject();
    sgkIsyeri: DosyaBorcluIsyeriSgkCevap | EmptyObject = new EmptyObject();
    takbis: BorcluTakbisSorgulamaCevap | EmptyObject = new EmptyObject();
    sgkhaciz: BorcluSgkHacizCevap | EmptyObject = new EmptyObject();
    bes: BorcluBesCevap | EmptyObject = new EmptyObject();
    takyidat: BorcluTasinmazTakyidatSorgulamaCevap | EmptyObject = new EmptyObject();
    hisse: BorcluTasinmazHisseSorgulamaCevap | EmptyObject = new EmptyObject();
    iski: BorcluIskiCevap | EmptyObject = new EmptyObject();
    icraDosyaKaydi: BorcluIcraDosyasiCevap | EmptyObject = new EmptyObject();
    gsm: BorcluGsmCevap | EmptyObject = new EmptyObject();
    postaCeki: BorcluPostaCekiCevap | EmptyObject = new EmptyObject();
    haciz: DosyaBorcluHacizInterface = new DosyaBorcluHacizInterface();
    tebligat: DosyaBorcluTebligatInterface = new DosyaBorcluTebligatInterface();
    digerTalep: DigerTalepParamsInterface = new DigerTalepParamsInterface();
    sgkMossip: BorcluSgkHacizCevap | EmptyObject = new EmptyObject();
    isKisiBool: boolean = false;
    isKurumBool: boolean = false;

    constructor(borclu: IBorcluBilgileri) {
        this.turu = borclu.turu;
        this.kisiKurumId = borclu.kisiKurumId;
        if (this.turu == BorcluTur.KISI) {
            this.borcluBilgileri = borclu.kisiTumDVO as IKisiTumDVO;
            this.isKisiBool = true;
            this.isKurumBool = false;
        } else {
            this.borcluBilgileri = borclu.kurumDVO as IKurumDVO;
            this.isKisiBool = false;
            this.isKurumBool = true;
        }
    }

    isKurum(): boolean {
        return this.turu == BorcluTur.KURUM;
    }

    isKisi(): boolean {
        return this.turu == BorcluTur.KISI;
    }

    getAd(): string {
        return this.isKisi() ?
            `${(this.borcluBilgileri as IKisiTumDVO).adi} ${(this.borcluBilgileri as IKisiTumDVO).soyadi}` :
            (this.borcluBilgileri as IKurumDVO).kurumAdi;
    }

    setBorcluErrorAllFields(message: string, haricAlanlar: Array<string> = []): void {
        this.ssk.message = message;
        this.egm.message = message;
        if (!haricAlanlar.includes("mernis"))
            this.mernis.message = message;
        this.mersis.message = message;
        this.sgkkamu.message = message;
        this.gib.message = message;
        this.sgkbagkur.message = message;
        this.bankaBilgileri.message = message;
        this.dib.message = message;
        this.sgkIsyeri.message = message;
        this.takbis.message = message;
        this.sgkhaciz.message = message;
        this.iski.message = message;
        this.icraDosyaKaydi.message = message;
        this.gsm.message = message;
        this.postaCeki.message = message;
        this.takyidat.message = message;
        this.hisse.message = message;
        this.bes.message = message;
    }

    async kotaIslemleri(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<void> {
        try {
            let bakiyeRes = await app.$uyap.SorguBakiyesi().run({dosyaId: dosyaId});
            console.log('KOTA: SorguBakiyesi cevap', JSON.stringify(bakiyeRes));

            // Kota varsa direk sorgu yap
            if (bakiyeRes.sorguKalanIslemSayisi > 0) {
                console.log('KOTA: kota dahilinde sorgu');
                return;
            }

            // Kota doldu - kullanıcı bakiye kullanmak istemiyor mu?
            if (!ucretliSorguyaDevamEt) {
                console.log('KOTA: kota kalmadı ve kullanıcı bakiye kullanmak istemiyor');
                throw new Error("Sorgu kotası kalmadı.");
            }

            // Kullanıcı bakiye kullanmak istiyor - bakiye kontrolü
            const mevcutBakiye = Number(bakiyeRes.sorguBakiye);

            if (mevcutBakiye >= SORGU_UCRETI) {
                // Bakiye yeterli, sorgu yap
                await app.$uyap.SorguDosyaKontrol().run({dosyaList: dosyaId});
                let avukat = await app.$uyap.AvukatKisiselBilgileriSorgulama().run({});
                app.$store.commit('setUyapAvukatBilgileri',avukat);
                console.log('KOTA: ücretli sorgu (bakiye kullanıldı)');
                return;
            }

            // Bakiye yetersiz - barokarttan yükleme yapılacak mı?
            if (barokarttanSorguBakiyesiYukle) {
                await app.$uyap.SorguBakiyeYukle().run({bakiye: SORGU_UCRETI, odemeTip: OdemeTipiEnum.Ebarobirlikkart});
                await app.$uyap.SorguDosyaKontrol().run({dosyaList: dosyaId});
                let avukat = await app.$uyap.AvukatKisiselBilgileriSorgulama().run({});
                app.$store.commit('setUyapAvukatBilgileri',avukat);
                console.log('KOTA: barokartan yüklendi ve ücretli sorgu yapıldı');
                return;
            }

            // Bakiye yok ve barokarttan yükleme de yapılmayacak
            console.log('KOTA: sorgu bakiyesi yetersiz');
            throw new Error(`Sorgu bakiyesi yetersiz. Gerekli bakiye: ${SORGU_UCRETI} TL, Mevcut bakiye: ${mevcutBakiye.toFixed(2)} TL`);

        } catch (e) {
            console.log('KOTA: hata', e.message);
            throw new Error(e.message);
        }
    }

    async queryBorcluSsk(dosyaId: string): Promise<void> {
        try {
            this.ssk = await app.$uyap.DosyaBorcluSSK().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.ssk.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluBes(dosyaId: string,ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<BorcluBesCevap> {
        try {
            let reqData = {
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            };
            this.bes = await app.$uyap.BorcluBes().run(reqData);
            let isDataCached = await app.$uyap.BorcluBes().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.bes = await app.$uyap.BorcluBes().run(reqData);
            return (this.bes as BorcluBesCevap);
        } catch (e) {
            this.bes.message = e.message;
            throw new Error(e.message);
        }
    }

    // todo: kullanılan yerleri düzelt
    async queryEgm(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<DosyaBorcluEgmCevap> {
        try {
            let reqData: DosyaBorcluEgmTalep = {
                dosyaId: dosyaId,
                kisiKurumId: this.kisiKurumId,
                pageIndex: 0,
                sorguBakiye: '',
            };
            let isDataCached = await app.$uyap.DosyaBorcluEgm().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.egm = await app.$uyap.DosyaBorcluEgm().run(reqData);
            return (this.egm as DosyaBorcluEgmCevap);
        } catch (e) {
            this.egm.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryEgmMahrumiyet(dosyaId: any): Promise<void> {
        try {
            await this.queryEgm(dosyaId);
            let egm = this.egm as DosyaBorcluEgmCevap;
            if (typeof egm.sorguSonucDVO != "undefined" && egm.sorguSonucDVO.aracBilgileri.aracList) {
                for (let arac of egm.sorguSonucDVO.aracBilgileri.aracList) {
                    try {
                        arac.mahrumiyet = await app.$uyap.DosyaBorcluEgmMahrumiyet().run({
                            dosyaId: dosyaId,
                            kisiKurumId: this.kisiKurumId,
                            plaka: arac.plakaSifreli
                        })
                    } catch (e) {
                        // @ts-ignore
                        arac.mahrumiyet.message = e.message;
                        console.warn(`Araç ${arac.plakaSifreli} mahrumiyet sorgusu başarısız:`, e.message);
                    }
                }
            }
        } catch (e) {
            console.warn("EGM mahrumiyet sorgusu genel hatası:", e.message);
            this.egm.message = e.message;
        }
    }

    async queryTasinmazHisse(dosyaId: any): Promise<void> {
        try {
            await this.queryBorcluTakbis(dosyaId);
            let takbis = this.takbis as BorcluTakbisSorgulamaCevap;
            if (takbis.sorguSonucu && takbis.sorguSonucDVO) {
                for (let tasinmaz of takbis.sorguSonucDVO) {
                    try{
                        // @ts-ignore
                        tasinmaz.hisse = await app.$uyap.BorcluTasinmazHisseSorgulama().run({
                            kisiKurumId: this.kisiKurumId,
                            dosyaId: dosyaId,
                            // @ts-ignore
                            tasinmazId: tasinmaz.tasinmazDVO.tasinmazId,
                        });
                        // @ts-ignore
                        this.hisse = tasinmaz.hisse;
                    }catch (e) {
                        // @ts-ignore
                        tasinmaz.hisse.message = e.message;
                    }
                }
            }
            this.takbis = takbis;
        } catch (e) {
            throw new Error(e.message);
        }

    }

    async queryTasinmazTakyidat(dosyaId: any): Promise<void> {
        try {
            await this.queryTasinmazHisse(dosyaId);
            let takbis = this.takbis as BorcluTakbisSorgulamaCevap;
            if (takbis.sorguSonucu && takbis.sorguSonucDVO) {
                for (let tasinmaz of takbis.sorguSonucDVO) {
                    // @ts-ignore
                    for (let hisse of tasinmaz.hisse.hisseList) {
                        try{
                            // @ts-ignore
                            hisse.takyidat = await app.$uyap.BorcluTasinmazTakyidatSorgulama().run({
                                kisiKurumId: this.kisiKurumId,
                                dosyaId: dosyaId,
                                // @ts-ignore
                                tasinmazId: tasinmaz.tasinmazDVO.tasinmazId,
                                hisseId: hisse.hisseId
                            });
                            this.takyidat = hisse.takyidat;
                        }catch (e) {
                            // @ts-ignore
                            hisse.takyidat.message = e.message;
                        }
                    }
                }
            }
            this.takbis = takbis;
            console.log("TAKYIDAT WITH TAKBIS",this.takbis);
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async queryBorcluMernis(dosyaId: string): Promise<void> {
        try {
            this.mernis = await app.$uyap.DosyaBorcluMernis().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.mernis.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluMersis(dosyaId: string): Promise<void> {
        try {
            this.mersis = await app.$uyap.DosyaBorcluMersis().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            });
        } catch (e) {
            this.mersis.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluSgkKamu(dosyaId: string): Promise<void> {
        try {
            this.sgkkamu = await app.$uyap.SgkKamu().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.sgkkamu.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluGib(dosyaId: string): Promise<void> {
        try {
            this.gib = await app.$uyap.BorcluGib().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.gib.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluSgkMossip(dosyaId: string): Promise<void> {
        try {
            this.sgkMossip = await app.$uyap.BorcluSgkHaciz().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
            });
        } catch (e) {
            this.sgkMossip.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluSgkBagkur(dosyaId: string): Promise<void> {
        try {
            this.sgkbagkur = await app.$uyap.DosyaBorcluBagkur().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.sgkbagkur.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluEmekliBagkur(dosyaId: string): Promise<void> {
        try {
            this.emekliBagkur = await app.$uyap.BagkurEmekli().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            });
        } catch (e) {
            this.emekliBagkur.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluEmekliSsk(dosyaId: string): Promise<void> {
        try {
            this.emekliSsk = await app.$uyap.SskEmekli().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            });
        } catch (e) {
            this.emekliSsk.message = e.message;
            throw new Error(e.message);
        }
    }

    // todo: kamu har gelince eklenecek
    async queryBorcluEmekliKamu(dosyaId: string): Promise<void> {
        try {
            this.emekliKamu = await app.$uyap.SskEmekli().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            });
        } catch (e) {
            this.emekliKamu.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluDib(dosyaId: string): Promise<void> {
        try {
            this.dib = await app.$uyap.BorcluDib().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.dib.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluSgkIsyeri(dosyaId: string): Promise<void> {
        try {
            this.sgkIsyeri = await app.$uyap.DosyaBorcluIsyeriSgk().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.sgkIsyeri.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluTakbis(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<void> {
        try {
            let reqData = {
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
            }
            let isDataCached = await app.$uyap.BorcluTakbisSorgulama().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.takbis = await app.$uyap.BorcluTakbisSorgulama().run(reqData);
        } catch (e) {
            this.takbis.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluSgkHaciz(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<void> {
        try {
            let reqData = {
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
            };
            let isDataCached = await app.$uyap.BorcluSgkHaciz().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.sgkhaciz = await app.$uyap.BorcluSgkHaciz().run(reqData);
        } catch (e) {
            this.sgkhaciz.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluIski(dosyaId: string): Promise<void> {
        try {
            this.iski = await app.$uyap.BorcluIski().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
                sorguBakiye: '',
            });
        } catch (e) {
            this.iski.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluIcraDosyaKaydi(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<void> {
        try {
            let reqData = {
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId,
            };
            let isDataCached = await app.$uyap.BorcluIcraDosyasi().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.icraDosyaKaydi = await app.$uyap.BorcluIcraDosyasi().run(reqData);
        } catch (e) {
            this.icraDosyaKaydi.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluGsm(dosyaId: string): Promise<void> {
        try {
            this.gsm = await app.$uyap.BorcluGsm().run({
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            });
        } catch (e) {
            this.gsm.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluPostaCeki(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<void> {
        try {
            let reqData: any = {
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            };
            let isDataCached = await app.$uyap.BorcluPostaCeki().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.postaCeki = await app.$uyap.BorcluPostaCeki().run(reqData);
        } catch (e) {
            this.postaCeki.message = e.message;
            throw new Error(e.message);
        }
    }

    async queryBorcluBankaBilgileri(dosyaId: string, ucretliSorguyaDevamEt: boolean = false, barokarttanSorguBakiyesiYukle: boolean = false): Promise<void> {
        try {
            let reqData = {
                kisiKurumId: this.kisiKurumId,
                dosyaId: dosyaId
            };
            let isDataCached = await app.$uyap.DosyaBorcluBankaBilgileri().isDataCached(reqData);
            if (!isDataCached)
                await this.kotaIslemleri(dosyaId, ucretliSorguyaDevamEt, barokarttanSorguBakiyesiYukle);
            this.bankaBilgileri = await app.$uyap.DosyaBorcluBankaBilgileri().run(reqData);
        } catch (e) {
            this.bankaBilgileri.message = e.message;
            throw new Error(e.message);
        }
    }

    async isSskDurumAktif(dosyaId: any): Promise<boolean> {
        await this.queryBorcluSsk(dosyaId);
        this.sskAktif = false;
        let ssk = this.ssk as DosyaBorcluSSKCevap;
        let donemYilAy = ssk.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO?.sigortaliBilgi?.donemYilAy;
        let durum = ssk.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO?.sigortaliBilgi?.durumKod;
        let aktifSayilabilecekDonem = new Date(app.$uyapHelper.getDateNow("/", "month -2", true)).getTime(); //2019/01
        let mevcutDosyaDonem = new Date(donemYilAy as string).getTime();
        if (durum == SigortaDurumKod.AKTIF) {
            if (mevcutDosyaDonem > aktifSayilabilecekDonem)
                this.sskAktif = true;
        }
        return this.sskAktif;
    }
}

class EmptyObject {
    message: string = "";
}